export default {"src":"/_next/static/media/lockLoginTop.68c4ac98.svg","height":23,"width":26};